export const PRODUCT_MAJOR_CATEGORY_OPTIONS = [
  { value: 'cleaning_consumables', label: '保洁耗材' },
  { value: 'engineering_consumables', label: '工程耗材' },
  { value: 'order_consumables', label: '秩序耗材' },
  { value: 'canteen_ingredients', label: '食堂食材' }
];

const LABEL_MAP = Object.fromEntries(
  PRODUCT_MAJOR_CATEGORY_OPTIONS.map(({ value, label }) => [value, label])
);

export function resolveMajorCategoryLabel(code) {
  return LABEL_MAP[code] || code || '-';
}

/** 物资数量展示：保留 1 位小数，去掉多余 0 */
export function formatMatQty(value) {
  return Number(value || 0).toFixed(1).replace(/\.0$/, '');
}
